import React from 'react'
import PropTypes from 'prop-types'

const Header = props => (
  <header id="header" style={props.timeout ? { display: 'none' } : {}}>
    <div className="logo">
      <span className="icon fa-diamond"></span>
    </div>
    <div className="content">
      <div className="inner">
        <h1>Chris and Paige</h1>
        <p>
          Met at Mac, Married at Mac
        </p>
      </div>
      <p> Saturday May 27th, 2023</p>
    </div>
    <nav>
      <ul>
        <li>
          <a
            onClick={() => {
              props.onOpenArticle('about')
            }}
            style={{ cursor: 'pointer' }}
          >
            About
          </a>
        </li>
        <li>
          <a
            onClick={() => {
              props.onOpenArticle('rsvp')
            }}
            style={{ cursor: 'pointer' }}
          >
            RSVP
          </a>
        </li>
        <li>
          <a
            onClick={() => {
              props.onOpenArticle('gifts')
            }}
            style={{ cursor: 'pointer' }}
          >
            Gifts
          </a>
        </li>
        <li>
          <a
            onClick={() => {
              props.onOpenArticle('location')
            }}
            style={{ cursor: 'pointer' }}
          >
            Travel / Accommodations
          </a>
        </li>
      </ul>
    </nav>
  </header>
)

Header.propTypes = {
  onOpenArticle: PropTypes.func,
  timeout: PropTypes.bool,
}

export default Header
